import { createSupabaseBrowserClient } from "@/lib/supabase/client";

/** Invoke a named Supabase Edge Function (one function per deployable, no monolithic router). */
export async function invokeEdgeFunction<T>(
  functionName: string,
  body: Record<string, unknown>,
  signal?: AbortSignal,
): Promise<T> {
  const sb = createSupabaseBrowserClient();
  const { data, error } = await sb.functions.invoke<T>(functionName, { body, signal });
  if (error) {
    throw new Error(error.message);
  }
  return data as T;
}
